import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSettingNextJSRscCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRscCategoryPage";
import { isRSCCategoryNavigationPath } from "@faire/retailer-visitor-shared/views/category/HubsRSC/isRSCCategoryNavigationPath";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { QueryParameters as CategoryQueryParameters } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { match as matchC1CategoryBrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/brand-value/brandValue/match";
import { match as matchC1CategoryRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/match";
import { match as matchC2CategoryBrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue/match";
import { match as matchC3CategoryBrandValueRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue/match";
import { match as matchC3CategoryRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/match";
import { match as matchC2CategoryRoute } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/match";
var supportedRoutesMatch = [
    matchC3CategoryBrandValueRoute,
    matchC2CategoryBrandValueRoute,
    matchC1CategoryBrandValueRoute,
    matchC3CategoryRoute,
    matchC2CategoryRoute,
    matchC1CategoryRoute
];
export var getShouldRequestRSCOnCategoryPage = function(options) {
    var prevPathname = options.prevPathname, prevSearch = options.prevSearch, pathname = options.pathname, search = options.search;
    return shouldShowRSCOnCategoryPage() && isCategoryPageRoute(pathname, search) && isProductFirstOrHubCategoryPage(pathname) && buildCategoryPageLoadKey(prevPathname, prevSearch) !== buildCategoryPageLoadKey(pathname, search);
};
var isProductFirstOrHubCategoryPage = function(pathname) {
    var _supportedRouteMatch;
    var supportedRouteMatch = supportedRoutesMatch.find(function(match) {
        return match(pathname);
    });
    var _supportedRouteMatch_params;
    var matchedPathParams = (_supportedRouteMatch_params = supportedRouteMatch === null || supportedRouteMatch === void 0 ? void 0 : (_supportedRouteMatch = supportedRouteMatch(pathname)) === null || _supportedRouteMatch === void 0 ? void 0 : _supportedRouteMatch.params) !== null && _supportedRouteMatch_params !== void 0 ? _supportedRouteMatch_params : {};
    // brandValue param is a hack to preselect a filter and is not part of navigation path
    matchedPathParams === null || matchedPathParams === void 0 ? true : delete matchedPathParams.brandValue;
    var navigationPath = Object.values(matchedPathParams).map(decodeURIComponent).join("|");
    return isRSCCategoryNavigationPath(navigationPath);
};
var shouldShowRSCOnCategoryPage = function() {
    var search = getLocationOrThrow().search;
    var rscParam = CategoryQueryParameters.parse(search).rsc;
    return getSettingNextJSRscCategoryPage(rscParam) && isLoggedInRetailer();
};
var isCategoryPageRoute = function(pathname, search) {
    if (!pathname.endsWith("/")) {
        pathname += "/";
    }
    return supportedRoutesMatch.some(function(match) {
        return match("".concat(pathname).concat(search)) !== null;
    });
};
var buildCategoryPageLoadKey = function(pathname, search) {
    var queryParam = CategoryQueryParameters.parse(search);
    return "".concat(pathname, "-").concat(queryParam.filters, "-").concat(queryParam.page);
};
